export function sortSkillsByLevel(item) {
    if (!Array.isArray(item)) {
        return [];
    }
    return item.slice(0).sort((a, b) => (a.level < b.level ? 1 : -1));
}
